import canUseDom from '~/utils/can-use-dom'

export default canUseDom &&
  (navigator.userAgent.indexOf('MSIE') !== -1 ||
    navigator.appVersion.indexOf('Trident/') > -1)
